export default function SliceString({string, prefix}) {
  let slice = (prefix ? prefix + " " : "") + string.slice(0, 8) + "..." ;
  return slice;
}
